import PropTypes from 'prop-types';
import React from 'react';
import { Icon } from 'components/v3';
import {
  EmptyStateContainer,
  EmptyGlowWrap,
  EmptyRing,
  EmptyCore,
  EmptyTitle,
  EmptyDescription,
  EmptyAction,
} from '../StyledComponents';

/**
 * "Spotlight glow" empty state for the Learning Hub.
 * Copy adapts to whether the user is searching, filtered to a topic,
 * or simply has no content in the current section.
 */
const EmptyState = ({ searchQuery, hasTopicFilter, onClearFilter }) => {
  let title = 'Fresh content is coming';
  let description =
    "We're putting together helpful videos for this section. Check back soon for new content.";

  if (searchQuery) {
    title = 'No matching videos';
    description = `We couldn't find any videos for "${searchQuery}". Try a different keyword or clear your filters.`;
  } else if (hasTopicFilter) {
    title = 'Nothing in this topic yet';
    description =
      'There are no videos for this topic right now. Explore all topics to see everything available.';
  }

  const showAction = Boolean(hasTopicFilter && onClearFilter);

  return (
    <EmptyStateContainer>
      <EmptyGlowWrap>
        <EmptyRing />
        <EmptyRing />
        <EmptyCore>
          <Icon name="play" size={38} />
        </EmptyCore>
      </EmptyGlowWrap>
      <EmptyTitle>{title}</EmptyTitle>
      <EmptyDescription>{description}</EmptyDescription>
      {showAction && (
        <EmptyAction onClick={onClearFilter}>Browse all topics</EmptyAction>
      )}
    </EmptyStateContainer>
  );
};

EmptyState.propTypes = {
  searchQuery: PropTypes.string,
  hasTopicFilter: PropTypes.bool,
  onClearFilter: PropTypes.func,
};

export default EmptyState;
